import { useTranslation } from 'react-i18next'
import { useParamsFromURL } from '../../hooks/useParamsFromURL'
import DamageRegistrationPage from '../../pages/DamageRegistration'
import { useAppStore } from '../../store/useAppStore'
import CustomWindow from '../CustomWindow'
import DamageRegistrationBtn from './DamageRegistrationBtn'
import { LayoutFor } from '../../types'
import { DHL_API } from '../../api'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

const OpenDamageRegistrationPageFab = () => {
  const damageRegistrationStep = useAppStore(
    (state) => state.damageRegistrationStep
  )
  const setDamageRegistrationStep = useAppStore(
    (state) => state.setDamageRegistrationStep
  )

  const {
    pNumber = '',
    depotCode,
    layoutFor,
    vehicleId,
    customTab,
    webView
  } = useParamsFromURL(['depotCode', 'vehicleId', 'pNumber', 'layoutFor', 'webView', 'customTab'])

  const { t } = useTranslation()

  const openDamageRegistrationPage = () => {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    setDamageRegistrationStep(1)
  }

  const { isSuccess, data } = useQuery([{ vehicleId, pnumber: pNumber }], () => DHL_API.get('api/fleet/storegear/damages/eligibility', { params: { vehicleId, pnumber: pNumber } }))

  useEffect(() => {
    if (isSuccess && data) {
      if (layoutFor !== LayoutFor.DAMAGE_DURING_ROUTE && data?.data === false) {
        if (webView === 'true') {
          if (window.Android) {
            window.Android.cancelVehicleDamageRegistrationApp()
            customTab === 'true' && window.close()
          }
        } else {
          window.close()
        }
      }
    }
  }, [isSuccess, data, layoutFor, webView, customTab])

  const closeDamageRegistrationPage = () =>
    setDamageRegistrationStep((step) => (step -= 1))

  const shouldOpenDamageRegistrationPage = damageRegistrationStep >= 1

  if (layoutFor === LayoutFor.DAMAGE_DURING_ROUTE) {
    return null
  }

  return (
    <>
      {damageRegistrationStep === 0 ? (
        <DamageRegistrationBtn
          handleClick={openDamageRegistrationPage}
          layoutFor={layoutFor}
        />
      ) : (
        <CustomWindow
          title={t('damage_registration_page.new_damage')}
          open={shouldOpenDamageRegistrationPage}
          handleClose={closeDamageRegistrationPage}
          noPadding
        >
          <DamageRegistrationPage
            depotCode={depotCode}
            vehicleId={vehicleId}
            pNumber={pNumber}
          />
        </CustomWindow>
      )}
    </>
  )
}

export default OpenDamageRegistrationPageFab
